import { REQUEST_DASHBOARD_SUCCESS } from '../constants/actionTypes';

const INITIAL_STATE = {
  monthlyFailedPosts: 0,
  monthlySuccessPosts: 0,
  monthlyTotalPosts: 0,
  previousFailedPosts: 0,
  previousSuccessPosts: 0,
  previousTotalPosts: 0,
  quarterlyFailedPosts: 0,
  quarterlySuccessPosts: 0,
  quarterlyTotalPosts: 0,
  todayFailedPosts: 0,
  todaySuccessPosts: 0,
  todayTotalPosts: 0,
  upcomingSchedules: [],
  weeklyFailedPosts: 0,
  weeklySuccessPosts: 0,
  weeklyTotalPosts: 0
};

export default function dashboard(state = INITIAL_STATE, action) {
  switch (action.type) {
    case REQUEST_DASHBOARD_SUCCESS:
      return {
        ...state,
        monthlyFailedPosts: action.payload.data.monthly_failed_posts,
        monthlySuccessPosts: action.payload.data.monthly_success_posts,
        monthlyTotalPosts: action.payload.data.monthly_total_posts,
        previousFailedPosts: action.payload.data.previous_failed_posts,
        previousSuccessPosts: action.payload.data.previous_success_posts,
        previousTotalPosts: action.payload.data.previous_total_posts,
        quarterlyFailedPosts: action.payload.data.quarterly_failed_posts,
        quarterlySuccessPosts: action.payload.data.quarterly_success_posts,
        quarterlyTotalPosts: action.payload.data.quarterly_total_posts,
        todayFailedPosts: action.payload.data.today_failed_posts,
        todaySuccessPosts: action.payload.data.today_success_posts,
        todayTotalPosts: action.payload.data.today_total_posts,
        upcomingSchedules: action.payload.data.upcoming_schedules,
        weeklyFailedPosts: action.payload.data.weekly_failed_posts,
        weeklySuccessPosts: action.payload.data.weekly_success_posts,
        weeklyTotalPosts: action.payload.data.weekly_total_posts
      };
    default:
      return state;
  }
}
